import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalResult } from '@app/v2/enums/modal-result.enum';
import {
    MdsButtonComponent,
    MdsDialogActionsComponent,
    MdsDialogComponent,
    MdsDialogContentComponent,
} from '@medpacesoftwaredevelopment/designsystem';

export interface MessageDialogData {
    title: string;
    bodyText: string;
    okayButtonLabel?: string;
    cancelButtonLabel?: string;
    showCancelButton?: boolean;
}

@Component({
    selector: 'medpace-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    imports: [MdsDialogComponent, MdsDialogContentComponent, MdsDialogActionsComponent, MdsButtonComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageDialogComponent {
    private dialogRef = inject(MatDialogRef<MessageDialogComponent>);
    public readonly data = signal<MessageDialogData>(inject(MAT_DIALOG_DATA));

    confirm() {
        this.dialogRef.close(ModalResult.Okay);
    }

    cancel() {
        this.dialogRef.close(ModalResult.Cancel);
    }
}
